export default __webpack_public_path__ + "a3ecaae6cf16dcd7df0c21e1591d9160.svg";